// extracted by mini-css-extract-plugin
export default {"quickMarcRecordInfoWrapper":"quickMarcRecordInfoWrapper---C70k7"};